/* eslint-disable */
import React from 'react';
import $ from 'jquery';
import { Form } from 'react-bootstrap';
import Tooltip from '../../../common/tooltip/main';
import CustomFieldKeyConfiguration from './custom_field_key_configuration';
import { determineUGTLocale } from '@components/asset/modal/tabs/edit/helpers';

export default class ConfigurationForm extends React.Component {
  submitUpdatedCustomFields = this.submitUpdatedCustomFields.bind(this);
  submitNewCustomFields = this.submitNewCustomFields.bind(this);
  submitDeletedCustomFields = this.submitDeletedCustomFields.bind(this);
  resolveFormSubmission = this.resolveFormSubmission.bind(this);
  custom_fields_to_delete = [];
  state = {
    custom_field_keys: [],
    new_custom_field_keys: [],
    submitting: false
  };

  componentDidMount() {
    this.getCustomFieldKeys();
  }

  getCustomFieldKeys() {
    $.ajax({
      type: "GET",
      url: `/api/v4/brandfolders/${this.props.brandfolder_key}/custom_field_keys${this.ugtLocaleParam()}`,
      context: this,
      beforeSend: function(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + BF_Token);
      },
      success: response => {
        let custom_field_keys = response.data.map(key => {
          return {
            key: key.id,
            name: key.attributes.name,
            allowed_values: key.attributes.allowed_values
          };
        });
        this.setState({
          custom_field_keys: _.sortBy(custom_field_keys, "name")
        });
      }
    });
  }

  newAndExistingCustomFieldKeys() {
    let { custom_field_keys, new_custom_field_keys } = this.state;
    return custom_field_keys.concat(new_custom_field_keys);
  }

  validName(custom_field_name) {
    const custom_field_names = this.newAndExistingCustomFieldKeys().filter((key) => !!key.name);
    const duplicates = custom_field_names.filter(({ name }) => name.trim() === custom_field_name.trim()).length >= 2;
    return !!custom_field_name && custom_field_name.trim().length > 0 && !duplicates;
  }

  validForm() {
    let custom_field_names = this.newAndExistingCustomFieldKeys().map(
      key => key.name
    );
    let empty_names =
      custom_field_names.filter(name => !!name === false).length > 0;
    let unique_names = Array.from(new Set(custom_field_names));
    let contains_duplicates = unique_names.length < custom_field_names.length;
    return !empty_names && !contains_duplicates;
  }

  addNewCustomField() {
    let new_custom_field_keys = this.state.new_custom_field_keys;
    new_custom_field_keys.push({ name: "", allowed_values: [] });
    this.setState({ new_custom_field_keys });
  }

  updateNewCustomField(index, name, allowed_values) {
    let new_custom_field_keys = this.state.new_custom_field_keys;
    new_custom_field_keys[index] = { name, allowed_values };
    this.setState({ new_custom_field_keys });
  }

  removeNewCustomField(index) {
    let new_custom_field_keys = this.state.new_custom_field_keys;
    new_custom_field_keys.splice(index, 1);
    this.setState({ new_custom_field_keys });
  }

  updateExistingCustomField(index, name, allowed_values) {
    let custom_field_keys = this.state.custom_field_keys;
    custom_field_keys[index] = {
      key: custom_field_keys[index].key,
      name,
      allowed_values
    };
    this.setState({ custom_field_keys });
  }

  removeExistingCustomField(index) {
    let custom_field_keys = this.state.custom_field_keys;
    let field_to_delete = custom_field_keys.splice(index, 1)[0];
    this.custom_fields_to_delete.push(field_to_delete);
    $("form#custom-fields-form").attr("data-locked", "true");
    this.setState({ custom_field_keys });
  }

  submitForm(event) {
    event.preventDefault();
    $(event.target).attr("data-locked", "false");
    if (!this.validForm()) {
      Notify.create({
        title: t("Please fix invalid fields before submitting"),
        type: "error"
      });
    } else if (!this.state.submitting) {
      this.setState({ submitting: true });
      Promise.all(this.submitUpdatedCustomFields())
        .then(() => {
          return this.submitNewCustomFields();
        })
        .then(() => {
          Promise.all(this.submitDeletedCustomFields()).then(() => {
            this.resolveFormSubmission();
          });
        })
        .catch(() => {
          this.setState({ submitting: false });
          // Generally when people swap names for custom fields ex: A.name => B.name
          Notify.create({
            title: t("An error occured and not all custom fields were updated."),
            body: t("Please try again. Names may have been swapped and conflict with one another."),
            type: "error"
          });
        });
    }
  }

  ugtLocaleParam() {
    const ugtLocale = determineUGTLocale();
    return ugtLocale ? `?ugt_locale=${ugtLocale}` : '';
  }

  submitUpdatedCustomFields() {
    return this.state.custom_field_keys.map(custom_field_key => {
      let data = {
        data: {
          attributes: {
            name: custom_field_key.name,
            allowed_values: custom_field_key.allowed_values || []
          }
        }
      };

      return $.ajax({
        type: "PUT",
        url: `/api/v4/custom_field_keys/${custom_field_key.key}${this.ugtLocaleParam()}`,
        data: JSON.stringify(data),
        beforeSend: function(xhr) {
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.setRequestHeader("Authorization", "Bearer " + BF_Token);
        },
        success: () => {}
      });
    });
  }

  submitNewCustomFields() {
    if (this.state.new_custom_field_keys.length > 0) {
      let attributes = this.state.new_custom_field_keys.map(customFieldKey => {
        return {
          name: customFieldKey.name,
          allowed_values: customFieldKey.allowed_values
        };
      });

      let data = { data: { attributes: attributes } };

      return $.ajax({
        type: "POST",
        url: `/api/v4/brandfolders/${
          this.props.brandfolder_key
        }/custom_field_keys${this.ugtLocaleParam()}`,
        data: JSON.stringify(data),
        beforeSend: function(xhr) {
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.setRequestHeader("Authorization", "Bearer " + BF_Token);
        },
        success: response => {}
      });
    }
  }

  submitDeletedCustomFields() {
    return this.custom_fields_to_delete.map(custom_field_key => {
      return $.ajax({
        type: "DELETE",
        url: `/api/v4/custom_field_keys/${custom_field_key.key}${this.ugtLocaleParam()}`,
        data: {},
        beforeSend: function(xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + BF_Token);
        },
        success: () => {}
      });
    });
  }

  resolveFormSubmission() {
    this.custom_fields_to_delete = [];
    this.setState({ submitting: false, new_custom_field_keys: [] });
    this.getCustomFieldKeys();
    Notify.create({
      title: t("Controlled Custom Fields Updated"),
      type: "success"
    });
  }

  renderCustomFieldKeys() {
    return this.state.custom_field_keys.filter((key) => !!key.name).map((custom_field_key, index) => {
      return (
        <CustomFieldKeyConfiguration
          key={index}
          index={index}
          name={custom_field_key.name}
          allowedValues={custom_field_key.allowed_values}
          valid={this.validName(custom_field_key.name)}
          updateCustomField={(index, name, allowed_values) =>
            this.updateExistingCustomField(index, name, allowed_values)
          }
          removeCustomField={index => this.removeExistingCustomField(index)}
        />
      );
    });
  }

  renderNewCustomFieldKeys() {
    return this.state.new_custom_field_keys.map((custom_field_key, index) => {
      return (
        <CustomFieldKeyConfiguration
          key={index}
          index={index}
          name={custom_field_key.name}
          allowedValues={custom_field_key.allowed_values}
          valid={this.validName(custom_field_key.name)}
          updateCustomField={(index, name, allowed_values) =>
            this.updateNewCustomField(index, name, allowed_values)
          }
          removeCustomField={index => this.removeNewCustomField(index)}
        />
      );
    });
  }

  renderSubmitButton() {
    if (this.state.submitting) {
      return (
        <button
          disabled
          type="submit"
          className="button primary lg custom-field-update-button"
        >
          {t('Updating Custom Fields ')}
          <img
            alt="loader gif"
            src="https://cdn.brandfolder.io/4OQZ5PW1/as/pv2ffm-cflif4-9vjcfz/downloading.gif"
          />
        </button>
      );
    }
    return (
      <button type="submit" className="button primary lg j-modal-submit-button custom-field-update-button">
        {t('Update Custom Fields')}
      </button>
    );
  }

  render() {
    return (
      <div
        className={
          "container j-controlled-custom-fields" +
          this.controlled_custom_fields_enabled
            ? ""
            : " s-hide"
        }
      >
        <div className="custom-fields-tooltip">
          <p>{t('Custom Field Names')}: {t('Allowed Values')}</p>
          <Tooltip
            tooltipId="allow-user-info"
            tooltipContent={t("Users will only be able to set custom fields on assets with the values specified below. Leave empty to allow free form custom field values.")}
          >
            <span className="bff-tool-tip" />
          </Tooltip>
        </div>
        <Form id="custom-fields-form" onSubmit={event => this.submitForm(event)}>
          <div className="brandfolder-settings__control-custom-fields--list">
            {this.renderCustomFieldKeys()}
            {this.renderNewCustomFieldKeys()}
          </div>
          <div className="add-custom-field-link">
            <a
              href="javascript:void(0)"
              onClick={event => this.addNewCustomField(event)}
              className="noline"
            >
              <span className="bff-plus" />
              {t('Add Custom Field')}
            </a>
          </div>
          {this.renderSubmitButton()}
        </Form>
      </div>
    );
  }
}
